import React, { Component } from 'react';
import { connect } from 'react-redux';
import {lowestDenom} from '../../../../config';

class Spread extends Component {
  render() {
    let display = this.props.market.sellSide == false ? 'none' : ''

    return (
      <div className='col s12' style={{padding: 0,display}}>
        <table className="white-text order-book" style={{tableLayout:"fixed",fontSize:"0.9em",height:'25px',borderTop:'1px solid white',borderBottom:'1px solid white'}}>
          <tbody>
            <tr>
              <td>Last Price: {this.props.lastPrice}</td>
              <td>Spread: {this.props.spread}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

function mapStateToProps(state,props) {

  let demand = state.orderbook.demand;
  let offers = state.orderbook.offers;
  let spread = demand && offers && demand.length > 0 && offers.length > 0 ? (offers[offers.length-1].price - demand[0].price) : null;
  let lastPrice = state.orderbook.stats.lastPrice

  return {
    market: state.ui_marketplace.market,
    spread,
    lastPrice,
  };
}


export default connect(mapStateToProps, {})(Spread);
